import { IUom } from "../interfaces/uom.interface";

export class Uom implements IUom {
  codeInternal: string;
  uomDisplay: string;
  codeDisplay: string;

  constructor(uom: IUom) {
    Object.keys(uom).map(key => this[key] = uom[key]);
}
}